
    import React from 'react'
    import Base from '@ucheba/ui/components/Icon'
    import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js"
    import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js"

    const symbol = new SpriteSymbol({
  "id": "icon__avatar-mask",
  "use": "icon__avatar-mask-usage",
  "viewBox": "0 0 96 96",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 96 96\" id=\"icon__avatar-mask\"><path d=\"M96 0v96H0V0h96ZM48 1C22.043 1 1 22.043 1 48a46.78 46.78 0 0 0 7.534 25.533c1.223 1.887-.17 7.637-4.178 17.25 10.305-3.349 16.388-4.425 18.248-3.229A46.78 46.78 0 0 0 48 95c25.957 0 47-21.043 47-47S73.957 1 48 1Z\" fill=\"#F7F9FC\" fill-rule=\"evenodd\" /></symbol>"
})
    sprite.add(symbol)

    export default React.memo(function IconAvatarMaskIcon(props) {
      const { className, ...restProps } = props
      return <Base.Icon className={className} id="icon__avatar-mask" {...restProps} />
    })
  